var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
var BreakpointContext = createContext(null);
export var useBreakpointContext = function () {
    var context = useContext(BreakpointContext);
    if (context === null) {
        throw new Error('useBreakpointContext must be used within an BreakpointContext');
    }
    return context;
};
function useCurrentBreakpoint() {
    var theme = useTheme();
    var isXs = useMediaQuery(theme.breakpoints.down('xs'));
    var isSm = useMediaQuery(theme.breakpoints.down('sm'));
    var isMd = useMediaQuery(theme.breakpoints.down('md'));
    var isLg = useMediaQuery(theme.breakpoints.down('lg'));
    if (isXs)
        return 'xs';
    if (isSm)
        return 'sm';
    if (isMd)
        return 'md';
    if (isLg)
        return 'lg';
    return 'xl';
}
export function BreakpointContextProvider(props) {
    var currentBreakpoint = useCurrentBreakpoint();
    return (_jsx(BreakpointContext.Provider, __assign({ value: currentBreakpoint }, { children: props.children })));
}
